export default __webpack_public_path__ + "images/d79de0acdd365186f3ceac5ff50e15a5-nationality_small.webp";